import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

interface IHeaderListItem {
  onClick: () => void;
  icon?: React.JSX.Element;
  primaryText: string;
}

export const HeaderListItem = (props: IHeaderListItem) => {
  const { onClick, icon, primaryText } = props;

  return (
    <ListItemButton
      onClick={onClick}
      sx={(theme) => ({
        paddingY: theme.spacing(2),
      })}
    >
      {icon && (
        <ListItemIcon
          sx={(theme) => ({
            "& .MuiSvgIcon-root": { fontSize: theme.typography.pxToRem(18), color: theme.palette.grey[600] },
          })}
        >
          {icon}
        </ListItemIcon>
      )}
      <ListItemText
        primary={primaryText}
        sx={{
          my: 0,
          "& .MuiListItemText-primary": {
            ...(icon && { marginLeft: 1 }),
            color: (theme) => theme.palette.grey[600],
          },
        }}
      />
    </ListItemButton>
  );
};
